import {
  API_ERROR,
  REPORTS_MENU,
  REPORTS_MENU_SUCCESS,
  REPORT_TYPE_CHECK,
  SET_PARAMS,
  REPORT_INPUT_CHANGE_VALUE,
  REPORT_SELECT_CHANGEVALUE,
  MR_REPORTS_LIST,
  MR_REPORTS_LIST_SUCCESS,
  MR_DOC_REPORT,
  MR_DOC_REPORT_SUCCESS,
  PI_REPORTS_LIST,
  PI_REPORTS_LIST_SUCCESS,
  PI_DOC_REPORT,
  PI_DOC_REPORT_SUCCESS,
  RFQ_REPORTS_LIST,
  RFQ_REPORTS_LIST_SUCCESS,
  RFQ_DOC_REPORT,
  RFQ_DOC_REPORT_SUCCESS,
  RFQ_DOC_PDF,
  Q_REPORTS_LIST,
  Q_REPORTS_LIST_SUCCESS,
  Q_DOC_REPORT,
  Q_DOC_REPORT_SUCCESS,
  Q_DOC_PDF,
  CQ_REPORTS_LIST,
  CQ_REPORTS_LIST_SUCCESS,
  CQ_DOC_REPORT,
  CQ_DOC_REPORT_SUCCESS,
  PO_REPORTS_LIST,
  PO_REPORTS_LIST_SUCCESS,
  PO_ITEM_REPORTS_LIST,
  PO_ITEM_REPORTS_LIST_SUCCESS,
  PO_DOC_REPORT,
  PO_DOC_REPORT_SUCCESS,
  PO_DOC_PDF,
  IGP_REPORTS_LIST,
  IGP_REPORTS_LIST_SUCCESS,
  IGP_REPORTS_PO_LIST,
  IGP_REPORTS_PO_LIST_SUCCESS,
  IGP_DOC_REPORT,
  IGP_DOC_REPORT_SUCCESS,
  MR_ITEMS_REPORTS_LIST,
  MR_ITEMS_REPORTS_LIST_SUCCESS,
  VENDOR_REPORTS_LIST,
  VENDOR_REPORTS_LIST_SUCCESS,
  RFQ_PENDING_REPORTS_LIST,
  RFQ_PENDING_REPORTS_LIST_SUCCESS,
  ITEM_WISE_REPORTS_LIST,
  ITEM_WISE_REPORTS_LIST_SUCCESS,
  UNIT_REPORTS_LIST,
  UNIT_REPORTS_LIST_SUCCESS,
  UNIT_DOC_REPORT,
  UNIT_DOC_REPORT_SUCCESS,
  UNIT_DOC_PDF,
  PO_AMENDAMENT_REPORTS_LIST,
  PO_AMENDAMENT_REPORTS_LIST_SUCCESS,
  SR_DOC_REPORT_SUCCESS,
  SR_DOC_REPORT,
  SR_RFQ_REPORTS_LIST,
  SR_RFQ_REPORTS_LIST_SUCCESS,
  SR_RFQ_DOC_REPORT,
  SR_RFQ_DOC_REPORT_SUCCESS,
  SR_RFQ_DOC_PDF,
  SR_Q_DOC_PDF,
  SR_Q_DOC_REPORT_SUCCESS,
  SR_Q_DOC_REPORT,
  WO_DOC_REPORT,
  WO_DOC_REPORT_SUCCESS,
  WO_DOC_PDF,
  SR_REPORTS_LIST,
  SR_REPORTS_LIST_SUCCESS,
  SI_REPORTS_LIST,
  SI_REPORTS_LIST_SUCCESS,
  SI_DOC_REPORT,
  SI_DOC_REPORT_SUCCESS,
  SR_CQ_REPORTS_LIST,
  SR_CQ_REPORTS_LIST_SUCCESS,
  SR_CQ_DOC_REPORT,
  SR_CQ_DOC_REPORT_SUCCESS,
  SRQ_REPORTS_LIST,
  SRQ_REPORTS_LIST_SUCCESS,
  WO_REPORTS_LIST,
  WO_REPORTS_LIST_SUCCESS,
  WO_ITEM_REPORTS_LIST,
  WO_ITEM_REPORTS_LIST_SUCCESS,
  REPORT_STATUS,
  DELAY_REPORTS_LIST,
  REPORT_DOWNLOAD,
  REPORT_DOWNLOAD_SUCCESS,
  PO_REPORTS_LIST_FOR_DOCUMENT,
  PO_REPORTS_LIST__FOR_DOCUMENT_SUCCESS,
  PENDING_PO_DOC_REPORT_SUCCESS,
  PENDING_PO_DOC_REPORT,
  CONSUMPTION_DETAILED_DOC_REPORT,
  CONSUMPTION_DETAILED_DOC_REPORT_SUCCESS,
  VENDOR_DUE_DETAILED_DOC_REPORT,
  VENDOR_DUE_DETAILED_DOC_REPORT_SUCCESS,
} from "./actionTypes";
export const getReportsMenu = (data) => {
  return {
    type: REPORTS_MENU,
    payload: { data },
  };
};
export const ReportsMenuSuccessful = (response) => {
  return {
    type: REPORTS_MENU_SUCCESS,
    payload: response,
  };
};

export const reportTypeCheck = ({ value }) => {
  return {
    type: REPORT_TYPE_CHECK,
    payload: { value },
  };
};
export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};
export const ReportsChangeValue = ({ key, value }) => {
  return {
    type: REPORT_INPUT_CHANGE_VALUE,
    payload: { key, value },
  };
};
export const ReportsSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: REPORT_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
// MR Reports
export const getMRreportslist = (data) => {
  return {
    type: MR_REPORTS_LIST,
    payload: { data },
  };
};
export const MRreportslistSuccessful = (response) => {
  return {
    type: MR_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};
export const getSRreportslist = (data) => {
  return {
    type: SR_REPORTS_LIST,
    payload: { data },
  };
};
export const SRreportslistSuccessful = (response) => {
  return {
    type: SR_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};
export const getMRDocReport = (MRId) => {
  return {
    type: MR_DOC_REPORT,
    payload: { MRId },
  };
};
export const getSRDocReport = (MRId) => {
  return {
    type: SR_DOC_REPORT,
    payload: { MRId },
  };
};
export const MRDocReportSuccessful = (response) => {
  return {
    type: MR_DOC_REPORT_SUCCESS,
    payload: response,
  };
};
export const SRDocReportSuccessful = (response) => {
  return {
    type: SR_DOC_REPORT_SUCCESS,
    payload: response,
  };
};
// PI Reports
export const getPIreportslist = (data) => {
  return {
    type: PI_REPORTS_LIST,
    payload: { data },
  };
};
export const PIreportslistSuccessful = (response) => {
  return {
    type: PI_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};
export const getPIDocReport = (PIId) => {
  return {
    type: PI_DOC_REPORT,
    payload: { PIId },
  };
};
export const PIDocReportSuccessful = (response) => {
  return {
    type: PI_DOC_REPORT_SUCCESS,
    payload: response,
  };
};
// SI Reports

export const getSIreportslist = (data) => {
  return {
    type: SI_REPORTS_LIST,
    payload: { data },
  };
};
export const SIreportslistSuccessful = (response) => {
  return {
    type: SI_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};
export const getSIDocReport = (PIId) => {
  return {
    type: SI_DOC_REPORT,
    payload: { PIId },
  };
};
export const SIDocReportSuccessful = (response) => {
  return {
    type: SI_DOC_REPORT_SUCCESS,
    payload: response,
  };
};

// RFQ Reports
export const getRFQreportslist = (data) => {
  return {
    type: RFQ_REPORTS_LIST,
    payload: { data },
  };
};
export const RFQreportslistSuccessful = (response) => {
  return {
    type: RFQ_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};
export const getRFQDocReport = (RFQId, rfqPDF) => {
  return {
    type: RFQ_DOC_REPORT,
    payload: { RFQId, rfqPDF },
  };
};
export const RFQDocReportSuccessful = (response) => {
  return {
    type: RFQ_DOC_REPORT_SUCCESS,
    payload: response,
  };
};
export const rfqPdf = (rfqPdf) => {
  return {
    type: RFQ_DOC_PDF,
    payload: { rfqPdf },
  };
};

export const getSR_RFQreportslist = (data) => {
  console.log("Hello World action");
  return {
    type: SR_RFQ_REPORTS_LIST,
    payload: { data },
  };
};
export const SR_RFQreportslistSuccessful = (response) => {
  return {
    type: SR_RFQ_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};
export const getSR_RFQDocReport = (SR_RFQId, rfqPDF) => {
  return {
    type: SR_RFQ_DOC_REPORT,
    payload: { SR_RFQId, rfqPDF },
  };
};
export const SR_RFQDocReportSuccessful = (response) => {
  return {
    type: SR_RFQ_DOC_REPORT_SUCCESS,
    payload: response,
  };
};

export const srRfqPdf = (rfqPdf) => {
  return {
    type: SR_RFQ_DOC_PDF,
    payload: { rfqPdf },
  };
};

// Quotation  Reports
export const getQreportslist = (data) => {
  return {
    type: Q_REPORTS_LIST,
    payload: { data },
  };
};
export const QreportslistSuccessful = (response) => {
  return {
    type: Q_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};

export const getSRQreportslist = (data) => {
  return {
    type: SRQ_REPORTS_LIST,
    payload: { data },
  };
};
export const SRQreportslistSuccessful = (response) => {
  return {
    type: SRQ_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};

export const getQDocReport = (QId, QuotationPdf) => {
  return {
    type: Q_DOC_REPORT,
    payload: { QId, QuotationPdf },
  };
};
export const QDocReportSuccessful = (response) => {
  return {
    type: Q_DOC_REPORT_SUCCESS,
    payload: response,
  };
};

export const getSRQDocReport = (QId, QuotationPdf) => {
  return {
    type: SR_Q_DOC_REPORT,
    payload: { QId, QuotationPdf },
  };
};
export const QDocSRReportSuccessful = (response) => {
  return {
    type: SR_Q_DOC_REPORT_SUCCESS,
    payload: response,
  };
};

export const QuotationPdf = (QuotationPdf) => {
  return {
    type: Q_DOC_PDF,
    payload: { QuotationPdf },
  };
};
export const SRQuotationPdf = (QuotationPdf) => {
  return {
    type: SR_Q_DOC_PDF,
    payload: { QuotationPdf },
  };
};
// Unit Report
export const getUnitreportslist = (data) => {
  return {
    type: UNIT_REPORTS_LIST,
    payload: { data },
  };
};
export const UnitreportslistSuccessful = (response) => {
  return {
    type: UNIT_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};
export const getUnitDocReport = (QId, UnitPdf) => {
  return {
    type: UNIT_DOC_REPORT,
    payload: { QId, UnitPdf },
  };
};
export const UnitDocReportSuccessful = (response) => {
  return {
    type: UNIT_DOC_REPORT_SUCCESS,
    payload: response,
  };
};
export const UnitPdf = (UnitPdf) => {
  return {
    type: UNIT_DOC_PDF,
    payload: { UnitPdf },
  };
};
// CQ  Reports
export const getCQreportslist = (data) => {
  return {
    type: CQ_REPORTS_LIST,
    payload: { data },
  };
};
export const CQreportslistSuccessful = (response) => {
  return {
    type: CQ_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};
export const getCQDocReport = (CQId) => {
  return {
    type: CQ_DOC_REPORT,
    payload: { CQId },
  };
};
export const CQDocReportSuccessful = (response) => {
  return {
    type: CQ_DOC_REPORT_SUCCESS,
    payload: response,
  };
};

export const getSRCQreportslist = (data) => {
  return {
    type: SR_CQ_REPORTS_LIST,
    payload: { data },
  };
};
export const SRCQreportslistSuccessful = (response) => {
  return {
    type: SR_CQ_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};
export const getSRCQDocReport = (CQId) => {
  return {
    type: SR_CQ_DOC_REPORT,
    payload: { CQId },
  };
};
export const SRCQDocReportSuccessful = (response) => {
  return {
    type: SR_CQ_DOC_REPORT_SUCCESS,
    payload: response,
  };
};

// PO  Reports
export const getPOreportslist = (data) => {
  return {
    type: PO_REPORTS_LIST,
    payload: { data },
  };
};
export const POreportslistSuccessful = (response) => {
  return {
    type: PO_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};
export const getPOreportslistForDocument = (data) => {
  return {
    type: PO_REPORTS_LIST_FOR_DOCUMENT,
    payload: { data },
  };
};
export const POreportslistSuccessfulForDocument = (response) => {
  console.log(response);
  return {
    type: PO_REPORTS_LIST__FOR_DOCUMENT_SUCCESS,
    payload: response,
  };
};
export const ReportStatus = (response) => {
  return {
    type: REPORT_STATUS,
    payload: response,
  };
};
export const reportDownload = (response) => {
  return {
    type: REPORT_DOWNLOAD,
    payload: response,
  };
};
export const reportDownloadSuccessful = (response) => {
  return {
    type: REPORT_DOWNLOAD_SUCCESS,
    payload: response,
  };
};
export const DelayReportsList = (response) => {
  return {
    type: DELAY_REPORTS_LIST,
    payload: response,
  };
};
export const getPOItemreportslist = (data) => {
  return {
    type: PO_ITEM_REPORTS_LIST,
    payload: { data },
  };
};
export const POItemreportslistSuccessful = (response) => {
  return {
    type: PO_ITEM_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};
export const getPODocReport = (POId, POPdf) => {
  return {
    type: PO_DOC_REPORT,
    payload: { POId, POPdf },
  };
};
export const getPendingPODocReport = (POId, POPdf) => {
  return {
    type: PENDING_PO_DOC_REPORT,
    payload: { POId, POPdf },
  };
};
export const PendingPODocReportSuccessful = (POId, POPdf) => {
  return {
    type: PENDING_PO_DOC_REPORT_SUCCESS,
    payload: { POId, POPdf },
  };
};
export const getConsumpptionDetailReport = (POId, POPdf) => {
  return {
    type: CONSUMPTION_DETAILED_DOC_REPORT,
    payload: { POId, POPdf },
  };
};
export const ConsumpptionDetailSuccessful = (POId, POPdf) => {
  return {
    type: CONSUMPTION_DETAILED_DOC_REPORT_SUCCESS,
    payload: { POId, POPdf },
  };
};
export const getVendorDueDetailReport = (POId, POPdf) => {
  return {
    type: VENDOR_DUE_DETAILED_DOC_REPORT,
    payload: { POId, POPdf },
  };
};
export const vendorDueDetailSuccessful = (POId, POPdf) => {
  return {
    type: VENDOR_DUE_DETAILED_DOC_REPORT_SUCCESS,
    payload: { POId, POPdf },
  };
};
export const PODocReportSuccessful = (response) => {
  return {
    type: PO_DOC_REPORT_SUCCESS,
    payload: response,
  };
};
//WO
export const getWOreportslist = (data) => {
  return {
    type: WO_REPORTS_LIST,
    payload: { data },
  };
};
export const WOreportslistSuccessful = (response) => {
  return {
    type: WO_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};
export const getWOItemreportslist = (data) => {
  return {
    type: WO_ITEM_REPORTS_LIST,
    payload: { data },
  };
};
export const WOItemreportslistSuccessful = (response) => {
  return {
    type: WO_ITEM_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};
export const getWODocReport = (WOId, WOPdf) => {
  return {
    type: WO_DOC_REPORT,
    payload: { WOId, WOPdf },
  };
};
export const WODocReportSuccessful = (response) => {
  return {
    type: WO_DOC_REPORT_SUCCESS,
    payload: response,
  };
};
export const PurchaseOrderPdf = (POPdf, pdfType) => {
  return {
    type: PO_DOC_PDF,
    payload: { POPdf, pdfType },
  };
};
export const WorkOrderPdf = (WOPdf, pdfType) => {
  return {
    type: WO_DOC_PDF,
    payload: { WOPdf, pdfType },
  };
};

// IGP  Reports

export const getIGPreportslist = (data) => {
  return {
    type: IGP_REPORTS_LIST,
    payload: { data },
  };
};
export const IGPreportslistSuccessful = (response) => {
  return {
    type: IGP_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};
export const IGPReportPOList = (data) => {
  return {
    type: IGP_REPORTS_PO_LIST,
    payload: { data },
  };
};
export const IGPreportPOlistSuccessful = (response) => {
  return {
    type: IGP_REPORTS_PO_LIST_SUCCESS,
    payload: response,
  };
};
export const getIGPDocReport = (IGPId) => {
  return {
    type: IGP_DOC_REPORT,
    payload: { IGPId },
  };
};
export const IGPDocReportSuccessful = (response) => {
  return {
    type: IGP_DOC_REPORT_SUCCESS,
    payload: response,
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

// MR Items Reports
export const getMRItemsReportslist = (data) => {
  return {
    type: MR_ITEMS_REPORTS_LIST,
    payload: { data },
  };
};
export const MRItemsReportslistSuccessful = (response) => {
  return {
    type: MR_ITEMS_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};

// Vendor List Reports
export const getVendorReportslist = (data) => {
  return {
    type: VENDOR_REPORTS_LIST,
    payload: { data },
  };
};
export const VendorReportslistSuccessful = (response) => {
  return {
    type: VENDOR_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};

// RFQ Pending Items

export const getRfqPendingReportslist = (data) => {
  return {
    type: RFQ_PENDING_REPORTS_LIST,
    payload: { data },
  };
};
export const RfqPendingReportslistSuccessful = (response) => {
  return {
    type: RFQ_PENDING_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};

// Item Wise Reports
export const getItemWiseReportslist = (data) => {
  return {
    type: ITEM_WISE_REPORTS_LIST,
    payload: { data },
  };
};
export const ItemWiseReportslistSuccessful = (response) => {
  return {
    type: ITEM_WISE_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};

//  PO Amendament Reports
export const getPOAmendamentReportslist = (data) => {
  return {
    type: PO_AMENDAMENT_REPORTS_LIST,
    payload: { data },
  };
};
export const POAmendamentReportslistSuccessful = (response) => {
  return {
    type: PO_AMENDAMENT_REPORTS_LIST_SUCCESS,
    payload: response,
  };
};

export let currentPdfType = null;

export const setPdfType = (type) => {
  currentPdfType = type;
};
